import React from 'react';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Signup from './pages/Signup';
import Login from './pages/Login';
import Home from './pages/Home';
import Blog from './pages/Blog';
import Blog2024 from './pages/Blog2024';
import Blog2025 from './pages/Blog2025';
import BlogDetail from './pages/BlogDetail'; // BlogDetail 컴포넌트
import NewPost from './pages/NewPost';
import EditPost from './pages/EditPost';
import About from './pages/About';
import Projects from './pages/Projects';
import Koiro from './pages/Koiro';
import Me from './pages/Me';
import Letters from './pages/Letters';
import AdminLetters from './pages/AdminLetters';
import Memories from './pages/Memories';
import Dashboard from './pages/Dashboard';
import DevBlog from './pages/DevBlog';
import WriteJekyllPost from './pages/WriteJekyllPost';
import GithubCallback, { GithubCallbackErrorBoundary } from './pages/GithubCallback';
import ScrollProgress from './components/ScrollProgress';
import ComingSoon from './sabbatical/ComingSoon';

function App() {
  const [unlocked, setUnlocked] = React.useState(
    () => localStorage.getItem('koiro_unlocked') === '1'
  );

  if (!unlocked) {
    return <ComingSoon onUnlock={() => setUnlocked(true)} />;
  }

  return (
    <ThemeProvider>
    <Router>
      <AuthProvider>
        <ScrollProgress />
        <Header />
        <Routes>
          <Route path="/signup" element={<Signup />} />
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Home />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/2024" element={<Blog2024 />} />
          <Route path="/blog/2025" element={<Blog2025 />} />
          {/* 수정된 부분: /blog/:slug로 블로그 글 상세 페이지로 라우팅 */}
          <Route path="/blog/:year/:slug" element={<BlogDetail />} />
          <Route path="/blog/:slug" element={<BlogDetail />} /> {/* 여기서 slug를 받습니다 */}
          <Route path="/blog/new" element={<NewPost />} />
          <Route path="/blog/edit/:slug" element={<EditPost />} />
          <Route path="/about" element={<About />} />
          <Route path="/about/koiro" element={<Koiro />} />
          <Route path="/journey" element={<Me />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/dev-blog" element={<DevBlog />} />
          <Route path="/dev-blog/write-jekyll" element={<WriteJekyllPost />} />
          <Route path="/dev-blog/github-callback" element={<GithubCallbackErrorBoundary><GithubCallback /></GithubCallbackErrorBoundary>} />
          <Route path="/letters" element={<Letters />} />
          <Route path="/admin-letters" element={<AdminLetters />} />
          <Route path="/memories" element={<Memories />} />
          <Route path="/dashboard" element={<Dashboard />} />
        </Routes>
        <Footer />
      </AuthProvider>
    </Router>
    </ThemeProvider>
  );
}

export default App;
